import useVersionCheck from '../hooks/useVersionCheck';

// Headless component that wires up the lazy frontend-version check. Renders
// nothing; the hook handles detection and the update toast.
export const VersionChecker = () => {
  useVersionCheck();
  return null;
};

export default VersionChecker;
